/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.ThreadAccessGrantRpc
 */

export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const AuditParamsDiscriminantKey = '@type';
export const BotHandoffDiscriminant = 'BOT_HANDOFF';
export const BotHandoffDiscriminantKey = '@type';
export const CrmSourceDiscriminant = 'CRM_SOURCE';
export const CrmSourceDiscriminantKey = '@type';
export const IntegratorAuditDiscriminant = 'INTEGRATOR';
export const IntegratorAuditDiscriminantKey = '@type';
export const ManualDiscriminant = 'MANUAL';
export const ManualDiscriminantKey = '@type';
export const MultipleAuditsDiscriminant = 'MULTIPLE';
export const MultipleAuditsDiscriminantKey = '@type';
export const SystemAutomaticDiscriminant = 'SYSTEM_AUTOMATIC';
export const SystemAutomaticDiscriminantKey = '@type';
export const SystemMigrationDiscriminant = 'SYSTEM_MIGRATION';
export const SystemMigrationDiscriminantKey = '@type';
export const SystemTestDiscriminant = 'SYSTEM_TEST';
export const SystemTestDiscriminantKey = '@type';
export const UnknownDiscriminant = 'UNKNOWN';
export const UnknownDiscriminantKey = '@type';
export const VisitorAuditDiscriminant = 'VISITOR';
export const VisitorAuditDiscriminantKey = '@type';
export const AssignmentUpdateMessageDiscriminant = 'ASSIGNMENT_UPDATE';
export const AssignmentUpdateMessageDiscriminantKey = '@type';
export const AutoReplySuppressedMessageDiscriminant = 'AUTO_REPLY_SUPPRESSED_MESSAGE';
export const AutoReplySuppressedMessageDiscriminantKey = '@type';
export const AvailabilityAutoReplyMessageDiscriminant = 'AVAILABILITY_AUTO_REPLY';
export const AvailabilityAutoReplyMessageDiscriminantKey = '@type';
export const BatchSmsGeneratedUserMessageDiscriminant = 'BATCH_SMS_GENERATED_USER_MESSAGE';
export const BatchSmsGeneratedUserMessageDiscriminantKey = '@type';
export const BatchWhatsAppGeneratedUserMessageDiscriminant = 'BATCH_WHATSAPP_GENERATED_USER_MESSAGE';
export const BatchWhatsAppGeneratedUserMessageDiscriminantKey = '@type';
export const BlockFilteredChangeInfoDiscriminant = 'BLOCK';
export const BlockFilteredChangeInfoDiscriminantKey = '@type';
export const ChatTranscriptSentMessageDiscriminant = 'CHAT_TRANSCRIPT_SENT';
export const ChatTranscriptSentMessageDiscriminantKey = '@type';
export const ChatTranscriptSentVisitorNotificationMessageDiscriminant = 'CHAT_TRANSCRIPT_SENT_VISITOR_NOTIFICATION';
export const ChatTranscriptSentVisitorNotificationMessageDiscriminantKey = '@type';
export const ChatflowContextDiscriminant = 'CHATFLOW';
export const ChatflowContextDiscriminantKey = '@type';
export const ConnectedAccountContextDiscriminant = 'CONNECTED_ACCOUNT';
export const ConnectedAccountContextDiscriminantKey = '@type';
export const ConnectedCrmObjectContextDiscriminant = 'CONNECTED_CRM_OBJECT';
export const ConnectedCrmObjectContextDiscriminantKey = '@type';
export const ContactAssociationMessageDiscriminant = 'CONTACT_ASSOCIATION';
export const ContactAssociationMessageDiscriminantKey = '@type';
export const ContextDiscriminantKey = '@type';
export const ContextUpdateMessageDiscriminant = 'CONTEXT_UPDATE';
export const ContextUpdateMessageDiscriminantKey = '@type';
export const ConversationMessageDiscriminantKey = '@type';
export const CrmObjectContextDiscriminant = 'CRM_OBJECT';
export const CrmObjectContextDiscriminantKey = '@type';
export const CrmObjectWorkflowEmailSentDiscriminant = 'CRM_OBJECT_WORKFLOW_EMAIL_SENT';
export const CrmObjectWorkflowEmailSentDiscriminantKey = '@type';
export const CustomDiscriminant = 'CUSTOM';
export const CustomDiscriminantKey = '@type';
export const CustomerAgentActionExecutionMessageDiscriminant = 'CUSTOMER_AGENT_ACTION_EXECUTION_MESSAGE';
export const CustomerAgentActionExecutionMessageDiscriminantKey = '@type';
export const CustomerAgentAutomatedMessageDiscriminant = 'CUSTOMER_AGENT_AUTOMATED_MESSAGE';
export const CustomerAgentAutomatedMessageDiscriminantKey = '@type';
export const CustomerAgentEventDiscriminant = 'CUSTOMER_AGENT_EVENT';
export const CustomerAgentEventDiscriminantKey = '@type';
export const CustomerAgentFeedbackMessageDiscriminant = 'CUSTOMER_AGENT_FEEDBACK';
export const CustomerAgentFeedbackMessageDiscriminantKey = '@type';
export const CustomerAgentMaintenanceModeMessageDiscriminant = 'CUSTOMER_AGENT_MAINTENANCE_MODE_MESSAGE';
export const CustomerAgentMaintenanceModeMessageDiscriminantKey = '@type';
export const CustomerPortalAccessGrantMessageDiscriminant = 'CUSTOMER_PORTAL_ACCESS_GRANT_MESSAGE';
export const CustomerPortalAccessGrantMessageDiscriminantKey = '@type';
export const EmailCapturePromptMessageDiscriminant = 'EMAIL_CAPTURE_PROMPT';
export const EmailCapturePromptMessageDiscriminantKey = '@type';
export const EmailCaptureResponseMessageDiscriminant = 'EMAIL_CAPTURE_RESPONSE';
export const EmailCaptureResponseMessageDiscriminantKey = '@type';
export const EmailIdentificationResultMessageDiscriminant = 'EMAIL_IDENTIFICATION_RESULT_MESSAGE';
export const EmailIdentificationResultMessageDiscriminantKey = '@type';
export const EntryUrlDiscriminant = 'ENTRY_URL';
export const EntryUrlDiscriminantKey = '@type';

/**
 * Virtual record for map with known enum keys
 */

export const FeedbackSubmissionMessageDiscriminant = 'FEEDBACK_SUBMISSION';
export const FeedbackSubmissionMessageDiscriminantKey = '@type';
export const FeedbackSurveyMessageDiscriminant = 'FEEDBACK_SURVEY';
export const FeedbackSurveyMessageDiscriminantKey = '@type';
export const FilteredChangeInfoDiscriminantKey = '@type';
export const FilteredChangeMessageDiscriminant = 'FILTERED_CHANGE';
export const FilteredChangeMessageDiscriminantKey = '@type';
export const ForwardedEmailUpdateContextDiscriminant = 'FORWARDED_EMAIL_UPDATE';
export const ForwardedEmailUpdateContextDiscriminantKey = '@type';
export const HelpDeskCommentReplyMessageDiscriminant = 'HELP_DESK_COMMENT_REPLY_SYSTEM_MESSAGE';
export const HelpDeskCommentReplyMessageDiscriminantKey = '@type';
export const HelpdeskTicketSplitUpdateMessageDiscriminant = 'HELP_DESK_TICKET_SPLIT_UPDATE_MESSAGE';
export const HelpdeskTicketSplitUpdateMessageDiscriminantKey = '@type';
export const InteractiveCardRequestMessageDiscriminant = 'INTERACTIVE_CARD_REQUEST_MESSAGE';
export const InteractiveCardRequestMessageDiscriminantKey = '@type';
export const InteractiveCardResponseMessageDiscriminant = 'INTERACTIVE_CARD_RESPONSE_MESSAGE';
export const InteractiveCardResponseMessageDiscriminantKey = '@type';
export const MarketingEmailReplyContextDiscriminant = 'MARKETING_EMAIL_REPLY';
export const MarketingEmailReplyContextDiscriminantKey = '@type';
export const NavigatorLanguagesDiscriminant = 'NAVIGATOR_LANGUAGES';
export const NavigatorLanguagesDiscriminantKey = '@type';
export const OfficeHoursMessageDiscriminant = 'OFFICE_HOURS';
export const OfficeHoursMessageDiscriminantKey = '@type';
export const PartialMessageDiscriminant = 'PARTIAL_MESSAGE';
export const PartialMessageDiscriminantKey = '@type';
export const ReadThreadMessageDiscriminant = 'READ_THREAD';
export const ReadThreadMessageDiscriminantKey = '@type';
export const SmsConsentAutomatedMessageDiscriminant = 'SMS_CONSENT_AUTOMATED_MESSAGE';
export const SmsConsentAutomatedMessageDiscriminantKey = '@type';
export const SpamFilteredChangeInfoDiscriminant = 'SPAM';
export const SpamFilteredChangeInfoDiscriminantKey = '@type';
export const ThreadCommentDiscriminant = 'THREAD_COMMENT';
export const ThreadCommentDiscriminantKey = '@type';
export const ThreadInboxUpdatedMessageDiscriminant = 'THREAD_INBOX_UPDATED';
export const ThreadInboxUpdatedMessageDiscriminantKey = '@type';
export const ThreadPausedOnGenericChannelMessageDiscriminant = 'THREAD_PAUSED_ON_GENERIC_CHANNEL';
export const ThreadPausedOnGenericChannelMessageDiscriminantKey = '@type';
export const ThreadReopenSplitMessageDiscriminant = 'THREAD_REOPEN_SPLIT_MESSAGE';
export const ThreadReopenSplitMessageDiscriminantKey = '@type';
export const ThreadStatusUpdateMessageDiscriminant = 'THREAD_STATUS_UPDATE';
export const ThreadStatusUpdateMessageDiscriminantKey = '@type';
export const TicketCreationFailureMessageDiscriminant = 'TICKET_CREATION_FAILURE';
export const TicketCreationFailureMessageDiscriminantKey = '@type';
export const TypicalResponseTimeMessageDiscriminant = 'TYPICAL_RESPONSE_TIME';
export const TypicalResponseTimeMessageDiscriminantKey = '@type';
export const TypingMessageDiscriminant = 'TYPING';
export const TypingMessageDiscriminantKey = '@type';
export const VisitorVerificationMessageDiscriminant = 'VISITOR_VERIFICATION_MESSAGE';
export const VisitorVerificationMessageDiscriminantKey = '@type';
export const WorkflowGeneratedUserMessageDiscriminant = 'WORKFLOW_GENERATED_USER_MESSAGE';
export const WorkflowGeneratedUserMessageDiscriminantKey = '@type';
export const AgentSenderDiscriminant = 'AGENT_SENDER';
export const AgentSenderDiscriminantKey = '@type';
export const AiInferenceMetadataDiscriminant = 'AI_INFERENCE_METADATA';
export const AiInferenceMetadataDiscriminantKey = '@type';
export const BotSenderDiscriminant = 'BOT_SENDER';
export const BotSenderDiscriminantKey = '@type';
export const CallMetadataDiscriminant = 'CALL_METADATA';
export const CallMetadataDiscriminantKey = '@type';
export const CitationDiscriminant = 'CITATION';
export const CitationDiscriminantKey = '@type';
export const CommonMessageDiscriminant = 'COMMON_MESSAGE';
export const CommonMessageDiscriminantKey = '@type';
export const ContactAttachmentDiscriminant = 'CONTACT';
export const ContactAttachmentDiscriminantKey = '@type';
export const CustomerAgentAssignmentDiscriminant = 'CUSTOMER_AGENT_ASSIGNMENT';
export const CustomerAgentAssignmentDiscriminantKey = '@type';
export const EmailMetadataDiscriminant = 'EMAIL_METADATA';
export const EmailMetadataDiscriminantKey = '@type';
export const EmailPreviousRepliesDiscriminant = 'EMAIL_PREVIOUS_REPLIES';
export const EmailPreviousRepliesDiscriminantKey = '@type';
export const EncryptedAttachmentDiscriminant = 'ENCRYPTED_ATTACHMENT';
export const EncryptedAttachmentDiscriminantKey = '@type';

/**
 * Virtual record for map with known enum keys
 */

export const FilesDiscriminant = 'FILES';
export const FilesDiscriminantKey = '@type';
export const InlineImagesDiscriminant = 'INLINE_IMAGES';
export const InlineImagesDiscriminantKey = '@type';
export const IntegratorSenderDiscriminant = 'INTEGRATOR_SENDER';
export const IntegratorSenderDiscriminantKey = '@type';
export const InteractiveCardDiscriminant = 'INTERACTIVE_CARD';
export const InteractiveCardDiscriminantKey = '@type';
export const LocationDiscriminant = 'LOCATION';
export const LocationDiscriminantKey = '@type';
export const MentionsDiscriminant = 'MENTIONS';
export const MentionsDiscriminantKey = '@type';
export const MessageFeedbackRequestDiscriminant = 'MESSAGE_FEEDBACK_REQUEST';
export const MessageFeedbackRequestDiscriminantKey = '@type';
export const MessageHeaderDiscriminant = 'MESSAGE_HEADER';
export const MessageHeaderDiscriminantKey = '@type';
export const MessagePositionDescriptorDiscriminant = 'MESSAGE_POSITION_DESCRIPTOR';
export const MessagePositionDescriptorDiscriminantKey = '@type';
export const QuickLinksDiscriminant = 'QUICK_LINKS';
export const QuickLinksDiscriminantKey = '@type';
export const QuickRepliesDiscriminant = 'QUICK_REPLIES';
export const QuickRepliesDiscriminantKey = '@type';
export const RedactedAttachmentDiscriminant = 'REDACTED_ATTACHMENT';
export const RedactedAttachmentDiscriminantKey = '@type';
export const RichMediaTemplatesDiscriminant = 'RICH_MEDIA_TEMPLATES';
export const RichMediaTemplatesDiscriminantKey = '@type';
export const SenderDiscriminantKey = '@type';
export const SocialMetadataAttachmentDiscriminant = 'SOCIAL_MEDIA_METADATA';
export const SocialMetadataAttachmentDiscriminantKey = '@type';
export const SystemSenderDiscriminant = 'SYSTEM_SENDER';
export const SystemSenderDiscriminantKey = '@type';
export const UnsupportedContentAttachmentDiscriminant = 'UNSUPPORTED_CONTENT';
export const UnsupportedContentAttachmentDiscriminantKey = '@type';
export const VidSenderDiscriminant = 'VID_SENDER';
export const VidSenderDiscriminantKey = '@type';
export const VisitorSenderDiscriminant = 'VISITOR_SENDER';
export const VisitorSenderDiscriminantKey = '@type';
export const WhatsAppTemplateMetadataDiscriminant = 'WHATSAPP_TEMPLATE_METADATA';
export const WhatsAppTemplateMetadataDiscriminantKey = '@type';
export let ComHubspotCvPubsubCoreMessageCommon;
(function (_ComHubspotCvPubsubCoreMessageCommon) {
  const AttachmentDiscriminantKey = _ComHubspotCvPubsubCoreMessageCommon.AttachmentDiscriminantKey = '@type';
})(ComHubspotCvPubsubCoreMessageCommon || (ComHubspotCvPubsubCoreMessageCommon = {}));
export const AssociationUpdateDiscriminant = 'ASSOCIATION_UPDATED';
export const AssociationUpdateDiscriminantKey = '@type';
export const CreatedUpdateDiscriminant = 'CREATED';
export const CreatedUpdateDiscriminantKey = '@type';
export const CrmObjectLifecycleUpdateDiscriminant = 'CRM_OBJECT_LIFECYCLE_UPDATE';
export const CrmObjectLifecycleUpdateDiscriminantKey = '@type';
export const CrmObjectUpdateDiscriminantKey = '@type';
export const PipelineStageUpdateDiscriminant = 'PIPELINE_STAGE_UPDATED';
export const PipelineStageUpdateDiscriminantKey = '@type';
export const EngagementDetailsMessageDiscriminant = 'ENGAGEMENT_DETAILS_MESSAGE';
export const EngagementDetailsMessageDiscriminantKey = '@type';
export const InitialMessageDiscriminant = 'INITIAL_MESSAGE';
export const InitialMessageDiscriminantKey = '@type';
export let ComHubspotEngagementsBaseEngagementsProtos;
(function (_ComHubspotEngagementsBaseEngagementsProtos) {})(ComHubspotEngagementsBaseEngagementsProtos || (ComHubspotEngagementsBaseEngagementsProtos = {}));
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const CustomerSuccessPortalErrorDiscriminant = 'CUSTOMER_SUCCESS_PORTAL';
export const CustomerSuccessPortalErrorDiscriminantKey = '@type';
export const FileErrorDiscriminant = 'FILE';
export const FileErrorDiscriminantKey = '@type';
export const HomeFeedErrorDiscriminant = 'HOME_FEED';
export const HomeFeedErrorDiscriminantKey = '@type';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export const SpaceAccessResolverErrorDiscriminant = 'SPACE_ACCESS_RESOLVER';
export const SpaceAccessResolverErrorDiscriminantKey = '@type';
export const SalesDocumentErrorDiscriminant = 'SALES_DOCUMENT';
export const SalesDocumentErrorDiscriminantKey = '@type';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const grantThreadAccessRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.ThreadAccessGrantRpc',
  rpcName: 'grantThreadAccess',
  auth: 'external',
  fingerprint: 'wnn5nGybcJb4vc75O3Jci5pZAL1fkDof',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};